<template>
  <v-container
    fluid
    class="ma-0 pa-0"
  >
    <analytics-platform
      v-for="item in analytics"
      :key="item.title"
      :content="item"

    ></analytics-platform>
  </v-container>
</template>

<script>
import AnalyticsPlatform from '../components/service/AnalyticsPlatform'

export default {
  components: {
    AnalyticsPlatform,
  },
  data() {
    return {
      analytics: [
        {
          title: '부동산',
          bottomComment: '리치고 회원가입 및 결제 후 약 90여가지의 이상의 부동산관련 최신 데이터 및 인덱스 서비스를 이용하실 수 있습니다.',
          backgroundColor: '#fafafa',
          items: [
            {
              title: '저평가지수',
              href: '#저평가지수',
              img: require('../assets/service/realestate/01.gif'),
              desc: '저평가 지역이 어디인지? 내 관심 지역의 저평가 정도를 한 눈에',
            },
            {
              title: '지수/가격통계',
              href: '#지수/가격통계',
              img: require('../assets/service/realestate/02.gif'),
              desc: '부동산 가격지수, 가격 등의 움직임을 플라워차트로 한 번에',
            },
            {
              title: '수요/공급',
              href: '#수요/공급',
              img: require('../assets/service/realestate/03.gif'),
              desc: '입주물량과 미분양 등의 수요, 공급 데이터를 한 번에',
            },
            {
              title: '단지분석',
              href: '#단지분석',
              img: require('../assets/service/realestate/04.gif'),
              desc: '개별 아파트 단지 분석을 한 번에',
            },
            {
              title: '실거래가',
              href: '#실거래가',
              img: require('../assets/service/realestate/05.gif'),
              desc: '쉽고 빠른 리치고 스타일의 실거래가 확인하기',
            },
            {
              title: '갭투자',
              href: '#갭투자',
              img: require('../assets/service/realestate/06.gif'),
              desc: '쉽고 빠르게 내 투자 금액에 적합한 아파트 고르기',
            },
            {
              title: '지역별',
              href: '#지역별',
              img: require('../assets/service/realestate/07.gif'),
              desc: '시도,시군구, 읍면동 기준으로 다양한 데이터를 한 번에 확인',
            },
            {
              title: '테마별',
              href: '#테마별',
              img: require('../assets/service/realestate/08.gif'),
              desc: '인구, 교통 등 부동산에 영향을 줄 수 있는 다양한 데이터 보기',
            },
          ],
        },
        {
          title: '경제',
          bottomComment: '리치고 회원가입 및 결제 후 약 30여가지의 이상의 다양한 경제 관련 최신 데이터 및 인덱스 서비스를 이용하실 수 있습니다.',
          backgroundColor: '#fff',
          items: [
            {
              title: '글로벌 경제',
              href: '#글로벌 경제',
              img: require('../assets/service/economy/01.gif'),
              desc: '세계경제의 돈의 흐름과 경기에 대해 현재 상황과 전망',
            },
            {
              title: '미국 경제',
              href: '#미국 경제',
              img: require('../assets/service/economy/02.gif'),
              desc: '미국의 경제, 금융, 부동산 시장의 현황 파악',
            },
            {
              title: '한국 경제',
              href: '#한국 경제',
              img: require('../assets/service/economy/03.gif'),
              desc: '한국의 다양한 경제지표를 통해 경제, 금융, 부동산 상황 점검',
            }
          ]
        }
      ]
    }
  }
}
</script>
